<template>
    <div id="box">
        <el-container>
          <el-aside style="background-color: #304156; min-height: 100vh" width="auto" class="navleft"><Navigation @unfold="navtion"/></el-aside>
            <el-container>
              <el-header style="height:56px"><Header/></el-header>
                <!-- <el-aside width="auto" class="navleft" :class="['navleft',show?'newNav':'']"><Navigation @unfold="navtion"/></el-aside> -->
                <el-main>
                    <!-- <Body/> -->
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import Header from '@/components/Header.vue'; // @ is an alias to /src
import Navigation from '@/components/Navigation.vue';
export default {
    name:'index',
    components: {
        Header,
        Navigation,
    },
    data(){
        return{
            show:true
        }
    },
    created(){
    },
    methods:{
        navtion(i){
            this.show = i
        }
    }
}
</script>
<style lang="scss">
    #box{
        height: 100%;
    }
    .el-container.is-vertical{
        height: 100%;
    }
    .el-container{
        display: -webkit-box;
    }
    .el-main{
        background-color: #E9ECF3
    }
    .navleft{
        // margin-top:110px;
        // animation: navrg .6s;
    }
    @keyframes navrg {
        0%   {margin-top: 0;}
        100%  {margin-top: 110px}
    }
    .newNav{
        margin-top:0;
        animation: navlt .2s;
    }
    @keyframes navlt {
        0%   {margin-top: 110px;}
        100%  {margin-top: 0%}
    }
</style>
